export default __webpack_public_path__ + "static/Shepherd-Pie-COOKED-1-a1ac892f9c35dd0cebee066126b5bfda.png";